import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";

export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryItemRequestApprovalLog = createAsyncThunk(
  "inventory/fetchInventoryItemRequestApprovalLog",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();

      params.append("limit", pageSize.toString());
      params.append("offset", ((page - 1) * pageSize).toString());

      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object") {
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(
        `/api/inventory_item_request/approval-log-list/?${params.toString()}`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0, // total items
      };
    } catch (error: any) {
      console.error(
        "fetch Item Request List error:",
        error.response?.data || error.message
      );
      throw new Error("Network Error");
    }
  }
);
